import { useEffect } from "react";
import { SalesHeader } from "@/components/SalesHeader";
import { HeroSection } from "@/components/HeroSection";
import { ProofSection } from "@/components/ProofSection";
import { ProblemSection } from "@/components/ProblemSection";
import { SolutionSection } from "@/components/SolutionSection";
import { ModulesSection } from "@/components/ModulesSection";
import { BonusSection } from "@/components/BonusSection";
import { ForWhoSection } from "@/components/ForWhoSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { AuthorSection } from "@/components/AuthorSection";
import { ValueRecapSection } from "@/components/ValueRecapSection";
import { PricingSection } from "@/components/PricingSection";
import { GuaranteeSection } from "@/components/GuaranteeSection";
import { FaqSection } from "@/components/FaqSection";
import { CtaFinalSection } from "@/components/CtaFinalSection";
import { SalesFooter } from "@/components/SalesFooter";

const SalesPage = () => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <>
      <SalesHeader />
      <main>
        <HeroSection />
        <ProofSection />
        <ProblemSection />
        <SolutionSection />
        <ModulesSection />
        <BonusSection />
        <ForWhoSection />
        <TestimonialsSection />
        <AuthorSection />
        <ValueRecapSection />
        <PricingSection />
        <GuaranteeSection />
        <FaqSection />
        <CtaFinalSection />
      </main>
      <SalesFooter />
    </>
  );
};

export default SalesPage;